import { render, staticRenderFns } from "./TemplateInheritanceChain.vue?vue&type=template&id=467c8ee4&scoped=true&"
import script from "./TemplateInheritanceChain.vue?vue&type=script&lang=ts&"
export * from "./TemplateInheritanceChain.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateInheritanceChain.vue?vue&type=style&index=0&id=467c8ee4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467c8ee4",
  null
  
)

export default component.exports